export enum TemplateType {
    BUILT_IN = 'BUILT_IN',
    CUSTOM = 'CUSTOM',
    EMPTY = 'EMPTY',
}

export type Template = {
    id: string;
    type: TemplateType;
    title: string;
    keywords: string;
    templateBoardId: string;
    mobilePreviewZoomScale?: number | null;
    mobilePreviewOffset?: { x: number; y: number } | null;
    forceClear: boolean;
};

export type SimpleTemplate = {
    id: string;
    displayName?: string;
};

export type TemplateCollection = {
    id: string;
    title: string;
    templates: (SimpleTemplate | Template)[];
};

export type TemplatesMap = {
    [id: string]: Template;
};

export type DefaultTemplate = SimpleTemplate | Template;

export type CmsTemplateData = {
    templates: TemplatesMap;
    defaultTemplates?: DefaultTemplate[];
    commonBoardTitles?: string[];
    collections: TemplateCollection[];
};

export enum NavigationLevel {
    DEFAULT,
    CATEGORIES,
    SUBCATEGORIES,
}

export type NavigationDetail =
    | { level: NavigationLevel.DEFAULT }
    | { level: NavigationLevel.CATEGORIES }
    | { level: NavigationLevel.SUBCATEGORIES; categoryId: string };
